import React from 'react'
import { cn } from './cn'

export interface DividerProps {
  /** The heritage sweep (replaces the old rainbow divider). */
  heritage?: boolean
  vertical?: boolean
  className?: string
}

export const Divider = ({ heritage, vertical, className }: DividerProps) => (
  <div
    role="separator"
    aria-orientation={vertical ? 'vertical' : 'horizontal'}
    className={cn(
      'shrink-0',
      vertical ? 'w-px self-stretch' : 'h-px w-full',
      heritage ? 'bg-[image:var(--plug-grad-heritage)] opacity-80' : 'bg-hairline',
      className
    )}
  />
)
